import { getCookie } from './cookie';
import CustomTooltip from './custom-tooltip';

// async function fetchFees(selectSeatsEid: string[]) {
// 	try {
// 	const response = await fetch(`/store/order/get-fees-by-tickets?${selectSeatsEid.map((eid) => `items[]=${eid}`).join('&')}&detailed=1`)
// 		const data = await response.json()
// 		return data
// 	} catch (error) {
// 		console.debug(error)
// 		return null
// 	}
// }

const updateFeeAjax = (items: { eid: string, price: string }[]) => {
	fetch(`/store/order/get-fees-by-tickets?${items.map((item) => `items[]=${item.eid}&prices[]=${item.price}`).join('&')}&detailed=1`)
		.then((response) => response.json())
		.then((obj) => {
			if (document.querySelector('#active-total-price')) (document.querySelector('#active-total-price') as HTMLElement).innerHTML = window.Locale.formatCurrency(obj.meta.finalTotal, window.myvars.langCode);
			if (document.querySelector('#subtotal-fees-row')) (document.querySelector('#subtotal-fees-row') as HTMLElement).innerHTML = renderFees(obj, window.detailsIsOpen)
			if (document.querySelector('#subtotal-fees-row-best-available')) (document.querySelector('#subtotal-fees-row-best-available') as HTMLElement).innerHTML = renderFees(obj, window.detailsIsOpen)

			// 初始化自定义 tooltip 并批量处理所有 tooltip 元素
			const tooltip = new CustomTooltip();
			tooltip.attachAll();
		})
		.catch((error) => {
			console.error('Error fetching fees:', error)
		})
}


function updateFees(seatsObj: any, fromDiscountPopup = false) {
	try {
		const items = Object.values(seatsObj).map((seat: any) => {
			// const price = fromDiscountPopup ? seat.price : seat.faceValuePrice || seat.price
			const {price, discountPrice, eid} = seat
			return {
				eid,
				price: discountPrice ? discountPrice.toString() : price.toString(),
			}
		})

		updateFeeAjax(items)
	} catch (err) {
		console.debug(err)
	}
}

function renderFees(data, open = false) {
	const {
		meta: {
			finalTotal,
			feeAndTaxTotal,
			totalBeforeFees,
			quantityTotal,
			orderProcessingFeeStoreCharge,
			facilityFeeTotal,
			convenienceFeeTotal,
			totalReal,
			giftCardRedeemAmountTotal,
		},
		allInPrice,
	} = data

	const finalTotal_value = window.Locale.formatCurrency(
		finalTotal,
		window.myvars.langCode,
		window.data.data.showDecimalOnPriceLegend,
	)
	const totalReal_value = window.Locale.formatCurrency(
		totalReal,
		window.myvars.langCode,
		window.data.data.showDecimalOnPriceLegend,
	)
	const totalBeforeFees_value = window.Locale.formatCurrency(
		totalBeforeFees,
		window.myvars.langCode,
		window.data.data.showDecimalOnPriceLegend,
	)
	const orderProcessingFeeStoreCharge_value = orderProcessingFeeStoreCharge ? window.Locale.formatCurrency(
		orderProcessingFeeStoreCharge,
		window.myvars.langCode,
		window.data.data.showDecimalOnPriceLegend,
	) : getCookie('couponApplied') === 'true' ? window.Locale.formatCurrency(
		orderProcessingFeeStoreCharge,
		window.myvars.langCode,
		window.data.data.showDecimalOnPriceLegend,
	) : ''

	const facilityFeeTotal_value = window.Locale.formatCurrency(
		facilityFeeTotal,
		window.myvars.langCode,
		window.data.data.showDecimalOnPriceLegend,
	)
	const convenienceFeeTotal_value = window.Locale.formatCurrency(
		convenienceFeeTotal,
		window.myvars.langCode,
		window.data.data.showDecimalOnPriceLegend,
	)


	const faceValueTooltip = window.myvars.faceValueTooltip
	const facilityFeeTooltip = window.myvars.facilityFeeTooltip
	const ticketingFeeTooltip = window.myvars.ticketingFeeTooltip
	const orderProcessingFeeTooltip = window.myvars.orderProcessingFeeTooltip

	// 创建自定义 tooltip 实例
	const tooltip = new CustomTooltip();

	return `
		<details ${open ? 'open' : ''} class="mb-5">
			<summary onclick="window.detailsIsOpen = !window.detailsIsOpen">
				<div class="trigger-label-info fees-trigger cursor-pointer bold mb-5">
					<span>${window.myvars.Subtotal} (<span>${quantityTotal}</span>) <span class="icon-svg icon-svg--size-20 caret__btn_trigger hand"></span></span>
					<div class=""><span>${(window.myvars.exchangeProcess || parseFloat(giftCardRedeemAmountTotal) > 0) ? totalReal_value : finalTotal_value}</span></div>
				</div>
			</summary>
			<div>
				<div class="flex flex-row justify-between items-center cursor-pointer gap-2"><span class="flex flex-row items-center cursor-pointer"><span>${window.myvars['Face Value']} x${quantityTotal}</span> ${tooltip.createInfoIcon(faceValueTooltip)}</span><span>${totalBeforeFees_value}</span></div>
				${parseFloat(facilityFeeTotal) > 0 || getCookie('couponApplied') === 'true' ? `<div class="flex flex-row justify-between items-center cursor-pointer gap-2"><span class="flex flex-row items-center cursor-pointer"><span>${window.myvars['Facility Fee']} x${quantityTotal}</span> ${tooltip.createInfoIcon(facilityFeeTooltip)}</span><span>${facilityFeeTotal_value}</span></div>` : ''}
				${parseFloat(convenienceFeeTotal) > 0 || getCookie('couponApplied') === 'true' ? `<div class="flex flex-row justify-between items-center cursor-pointer gap-2"><span class="flex flex-row items-center cursor-pointer"><span>${window.myvars['Ticketing Fee']} x${quantityTotal}</span> ${tooltip.createInfoIcon(ticketingFeeTooltip)}</span><span>${convenienceFeeTotal_value}</span></div>` : ''}
				${parseFloat(orderProcessingFeeStoreCharge) > 0 || (getCookie('couponApplied') === 'true' && parseFloat(orderProcessingFeeStoreCharge) >= 0) ? `<div class="flex flex-row justify-between items-center cursor-pointer gap-2"><span class="flex flex-row items-center cursor-pointer"><span>${window.myvars['Order Processing Fee']}</span> ${tooltip.createInfoIcon(orderProcessingFeeTooltip)}</span><span>${orderProcessingFeeStoreCharge_value}</span></div>` : ''}
			</div>
		</details>
	`
}

export default updateFees
